/* ========================================================================
   General
 ========================================================================== */

app.general = (function () {
  'use strict';

  function initEmailLinks() {
    // Handle base-64 encoded mailto-links
    const links = document.querySelectorAll('a[data-email]');

    links.forEach((el) => {
      el.addEventListener('click', (event) => {
        let email = atob(el.getAttribute('data-email'));
        window.location.href = 'mailto:' + email;
      });
    });
  }

  function initLax() {
    lax.init();

    // Add a driver that we use to control our animations
    lax.addDriver('scrollY', function () {
      return window.scrollY;
    });

    lax.addElements('.wideImage__image.has-lax', {
      scrollY: {
        translateY: [
          ['elInY', 'elOutY'],
          [0, -250],
        ],
      },
    });
  }

  function initVideoLinks() {
    const links = document.querySelectorAll('.js-showVideo');

    links.forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();

        openVideoLightbox(el.href);
      });
    });
  }

  function openVideoLightbox(videoUrl) {
    if (!videoUrl) return;

    if (util.vimeoRegex.test(videoUrl) || util.hasCookieConsent('marketing')) {
      var lightbox = new BasicLightbox(
        '<div class="linkBlocks__lightbox">' + util.getVideoEmbedHtmlFromUrl(videoUrl) + '</div>'
      );

      // DATALAYER
      window.dataLayer.push({
        event: 'watchVideo',
        pageUrl: window.location.pathname,
        videoUrl: videoUrl,
      });

      lightbox.show();
    } else {
      var lightbox = new BasicLightbox(
        '<div class="basicLightbox__consent">' +
          '<p>We willen u graag een video laten zien, maar we mogen deze video alleen laten zien als u toestemming geeft voor marketing cookies.</p>' +
          '<p><button class="button" onclick="app.general.updateLightboxVideoConsent(this); return false;" data-video-url="' +
          videoUrl +
          '">OK, toon de video</button></p>' +
          '</div>'
      );

      lightbox.show();
    }
  }

  function updateLightboxVideoConsent(button) {
    util.updateCookieConsent('marketing');

    var lightboxContainer = button.closest('.basicLightbox');
    if (!lightboxContainer) return;

    var videoUrl = button.dataset.videoUrl;
    if (!videoUrl) return;

    lightboxContainer.remove();
    openVideoLightbox(videoUrl);
  }

  const updateAppHeight = util.debounce(() => {
    document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
  }, 250);

  function initAppHeight() {
    // Init app height
    updateAppHeight();

    // Handle app height on resize
    window.addEventListener(
      'resize',
      () => {
        updateAppHeight();
      },
      { passive: true }
    );
  }

  function initMatchHeights() {
    const hero1 = document.querySelector('.js-hero1');

    if (hero1) {
      const titles = hero1.querySelectorAll('.hero1__twoColumns__item h2');
      const paragraphs = hero1.querySelectorAll('.hero1__twoColumns__item p');
      const buttons = hero1.querySelectorAll('.hero1__twoColumns__buttons a');

      if (titles.length) {
        MatchHeight(titles, { mediaQuery: breakpoint_sm });
      }

      if (paragraphs.length) {
        MatchHeight(paragraphs, { mediaQuery: breakpoint_sm });
      }

      if (buttons.length) {
        MatchHeight(buttons, { mediaQuery: breakpoint_sm });
      }
    }

    const hero2 = document.querySelector('.js-hero2');

    if (hero2) {
      const buttons = hero2.querySelectorAll('.hero2__twoColumns__buttons a');

      if (buttons.length) {
        MatchHeight(buttons, { mediaQuery: breakpoint_sm });
      }
    }
  }

  // Expose public functions and variables
  return {
    initEmailLinks: initEmailLinks,
    initVideoLinks: initVideoLinks,
    updateLightboxVideoConsent: updateLightboxVideoConsent,
    openVideoLightbox: openVideoLightbox,
    initLax: initLax,
    initAppHeight: initAppHeight,
    updateAppHeight: updateAppHeight,
    initMatchHeights: initMatchHeights,
  };
})();
